'use strict';

export class MemberNavigation {
  constructor() {
    var refereceLink = $('.view-display-id-user_local_group_link_hidden');
    var memberNavigation = $('.region-content-left nav');
  
    // inject my local group
    (function () {
      var localGroupLink = $("a[href='/my-local-group']");

      if (localGroupLink.length < 1 || refereceLink.length < 1) return;

      var url = refereceLink.find('.views-field-title a').attr('href');

      localGroupLink.attr('href', url);

      var calendarLink = $("a[href='/my-local-group/calendar'");

      if (calendarLink.length < 1) return;

      calendarLink.attr('href', `${url}#calendar`)
    })();

    // Group links
    (function () {
      var groupLinksElement = refereceLink.find('#group-links');

      if (groupLinksElement.length < 1) return;

      var groupLinks = groupLinksElement.data();

      // Group manage
      (function () {

        var link = memberNavigation.find('.local-group');
        if (link.length < 1) return;

        link.attr('href', groupLinks.manage);
        link.css('pointer-events', 'unset');
      })();

      // Group Content
      (function () {
        var link = memberNavigation.find('.group-content');

        if (link.length < 1) return;

        link.attr('href', groupLinks.nodes);
      })();

      // Group Members
      (function () {
        var link = memberNavigation.find('.group-members');

        if (link.length < 1) return;
        link.attr('href', groupLinks.members);
      })();

      // Group Content
      (function () {
        var link = memberNavigation.find('.group-member-requests');

        if (link.length < 1) return;

        link.attr('href', groupLinks.pending);
      })();
    })();


    // My local group admin link (inject group id to links)
    (function () {
      var localGroupMenu = $('.local-group-admin ~ .menu_link_content');

      var links = memberNavigation.find('.menu-item a');

     
      var groupLinksElement = refereceLink.find('#group-links');

      if (groupLinksElement.length < 1) return;
      console.log(links, groupLinksElement.data('id'), 'teest');
      links.each(function(key, link) {
        var href = $(link).attr('href');
        href = href.replace("%7B%7Bgid%7D%7D", groupLinksElement.data('id'));
        href = href.replace("{{gid}}", groupLinksElement.data('id'));

        var editNode = refereceLink.find('.views-field-edit-node a').attr('href');
        href = href.replace("/{{edit_node}}", editNode);
        href = href.replace("/%7B%7Bedit_node%7D%7D", editNode);
        $(link).attr('href', href);
      });
      
    })();


    // Open currently active tab
    (function () {
      var path = window.location.pathname;

      if (memberNavigation.length < 1) return;

      var currentLink = memberNavigation.find(`.menu a[href="${path}"]`);

      currentLink.parent('.menu-item').addClass('menu-item--active-trail');
      currentLink.closest('.menu-level-1').show();
      currentLink.closest('.menu-item--expanded').addClass('expanded');
      // console.log("member navigation set active", currentUrl, window.location.pathname);
    })();
  }
}
